import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { CalendarModel } from '../../models/view-schedule/booking-detail.model';
import { RequestAppointmentUrl } from '../../shared/urls/request-appointment.url';

@Injectable()
export class ViewScheduleService {
  constructor(public baseService: BaseService) {
  }
    getBookingList(param) {
        const url = RequestAppointmentUrl.GET_ALL_BOOKINGS;
        return this.baseService.postData(url, param);
    }

    getBookingCache(centreId) {
        const url = RequestAppointmentUrl.GET_BOOKING_CACHE.replace("{centreId}", centreId);
        return this.baseService.getData(url);
    }

    addBooking(param) {
        const url = RequestAppointmentUrl.ADD_BOOKING;
        return this.baseService.postData(url, param);
    }

    getAllCentre() {
        const url = RequestAppointmentUrl.GET_ALL_CENTRE;
        return this.baseService.getAll(url);
    }

    changeTimeBooking(id, param){
        const url = RequestAppointmentUrl.CHANGE_TIME_BOOKING + `${id}`;
        return this.baseService.put(url, param);
    }
}


const bookingInfo = <CalendarModel>{
    bookingList : [
        {
          id: '1',
          title: 'BOOKED', // booking ref or patient name
          class: 'Block', // status
          start: '2018-01-11T01:00:00',
          end: '2018-01-11T02:30:24',
          readOnly: true,
          status: -1,
          bookingType: -1
      },
      {
          id: '2',
          title: 'booking ref', // booking ref
          class: 'Arrived', // status
          start: '2018-01-10T01:00:00',
          end: '2018-01-10T01:30:00',
          readOnly: false,
          status: 2,
          bookingType: 1
      }
    ],
    disableDates: ['2018-01-09'],
    disableTimes: [
        /* {
            start: "0:00",
            end: "8:00"
        },
        {
            start: "12:00",
            end: "13:00"
        },
        {
            start: "17:00",
            end: "24:00"
        } */
    ]
};







// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/view-schedule.service.ts